.screen {
	min-height: 100%;
	padding: var(--space-7) var(--space-5);
	max-width: var(--screen-max);
	margin: 0 auto;
}

.header {
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	gap: var(--space-5);
	margin-bottom: var(--space-7);
}

.title {
	font-size: 2rem;
	font-weight: 600;
	margin: 0;
	letter-spacing: -0.01em;
}

.subtitle {
	margin: var(--space-1) 0 0 0;
	color: var(--ink-muted);
}

.invite {
	margin-bottom: var(--space-6);
}

.settings {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background: none;
	border: 1px solid var(--border);
	border-radius: var(--radius-md);
	padding: var(--space-2);
	color: var(--ink-muted);
	cursor: pointer;
}

.settings:hover {
	color: var(--ink);
	background: var(--surface-card);
}

.grid {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: var(--space-4);
	/* Container queries let widgets size their min-height from the grid's
	   own width, so a 2×1 widget cell stays as tall as a 1×1 tile would be. */
	container-type: inline-size;
}

@media (min-width: 640px) {
	.grid {
		grid-template-columns: repeat(4, 1fr);
	}
}

.cell {
	border-radius: var(--radius-lg);
	background: var(--tile-bg, var(--surface-card));
	box-shadow: var(--shadow-card);
	color: var(--ink);
	padding: var(--space-5) var(--space-4);
	cursor: pointer;
	transition:
		transform 0.15s ease,
		box-shadow 0.15s ease;
	/* One column width (gap subtracted) — keeps widget rows aligned with
	   tile rows even when a row contains no tiles. */
	min-height: calc((100cqw - var(--space-4)) / 2);
}

@media (min-width: 640px) {
	.cell {
		min-height: calc((100cqw - 3 * var(--space-4)) / 4);
	}
}

.cell:hover {
	transform: translateY(-2px);
	box-shadow: var(--shadow-card-hover);
}

.cell:active {
	transform: translateY(0);
}

.cell:focus-visible {
	outline: 2px solid var(--accent-sage);
	outline-offset: 2px;
}

.defaultTile {
	display: grid;
	place-items: center;
	gap: var(--space-3);
	height: 100%;
}

.emoji {
	font-size: 3rem;
	line-height: 1;
}

.name {
	font-weight: 600;
	font-size: 1rem;
}

.tint-sage {
	--tile-bg: color-mix(in oklab, var(--accent-sage) 18%, var(--surface-card));
}
.tint-apricot {
	--tile-bg: color-mix(
		in oklab,
		var(--accent-apricot) 22%,
		var(--surface-card)
	);
}
.tint-terracotta {
	--tile-bg: color-mix(
		in oklab,
		var(--accent-terracotta) 24%,
		var(--surface-card)
	);
}
.tint-lilac {
	--tile-bg: color-mix(
		in oklab,
		var(--accent-lilac) 22%,
		var(--surface-card)
	);
}
